<template>
  <div>
    <v-card flat>
      <v-form @submit.prevent="sendSMS" v-model="isFormValid" ref="form">
        <v-card-text class="ml-4">Select Group</v-card-text>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title
                  >Contact Groups[{{ selectedGroups.length }}]</v-card-title
                >
                <v-card-text
                  ><v-alert
                    text
                    prominent
                    color="primary"
                    icon="mdi-account-group-outline"
                  >
                    Select group </v-alert
                  ><v-select
                    v-model="selectedGroups"
                    :items="groupOptions"
                    :rules="requiredRule"
                    label="Select Contact Groups"
                    multiple
                    outlined
                    dense
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @mousedown.prevent @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              selectedGroups.length > 0 ? 'indigo darken-4' : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:append-item>
                      <v-divider class="mb-2"></v-divider>
                      <v-list-item disabled>
                        <v-list-item-avatar color="grey lighten-3">
                          <v-icon> mdi-account </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content v-if="selectedAllGroups">
                          <v-list-item-title>
                            You selected all contact groups!
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content v-else-if="selectedSomeGroups">
                          <v-list-item-title>
                            Contact Group Count
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ selectedGroups.length }}
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-content v-else>
                          <v-list-item-title>
                            Go ahead, make a selection above!
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select></v-card-text
                >
              </v-card></v-flex
            >
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title>Compose SMS</v-card-title>

                <v-card-text>
                  <v-select
                    v-model="selectedTemplate"
                    :items="templateOptions"
                    label="Select Template"
                    outlined
                    dense
                  ></v-select>
                  <v-textarea
                    v-model="selectedTemplateMessage"
                    :counter="300"
                    :rules="messageRules"
                    outlined
                    name="input-7-4"
                    label="Message"
                    placeholder="Type your message here (avoid emoji)."
                    dense
                  ></v-textarea>
                  <v-divider></v-divider>
                  <v-select
                    v-model="selectedSenderId"
                    class="mt-4"
                    :items="senderIdOptions"
                    label="--Select SenderID--"
                    outlined
                    dense
                    :rules="senderIdRules"
                  ></v-select>
                  <v-checkbox
                    v-model="checkbox"
                    label="Schedule this message"
                  ></v-checkbox>
                  <v-btn
                    v-if="!checkbox"
                    class="primary white--text lowercase-text"
                    plain
                    :loading="$store.state.loading.sendBtn.load"
                    :disabled="$store.state.loading.sendBtn.disabled"
                    type="submit"
                  >
                    Send Now
                  </v-btn>
                </v-card-text>
              </v-card></v-flex
            ></v-layout
          >
        </v-card-text>
      </v-form>
    </v-card>
    <DialogSchedule
      @close="checkbox = false"
      v-if="checkbox"
      :groupIds="groupIdsArray"
      :selectedTemplateMessage="selectedTemplateMessage"
      :selectedSenderId="selectedSenderId"
    />
  </div>
</template>

<script>
import DialogSchedule from "../Dialogs/ScheduleGroupDialog";
export default {
  props: ["templates", "senderIds", "groups"],
  components: { DialogSchedule },
  data: () => ({
    selectedTemplate: null,
    selectedTemplateMessage: "",
    selectedSenderId: null,
    senderIdRules: [(v) => !!v || "Sender ID is required"],
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => v.length <= 300 || "Message must be 160 characters or fewer",
    ],
    checkbox: false,
    groupOptions: [],
    selectedGroups: [],
    requiredRule: [(v) => (v && v.length > 0) || "This field is required"],
    groupIdsArray: null,
    isFormValid: false,
  }),
  watch: {
    selectedTemplate() {
      // Clear customMessage when a template is selected
      const selectedTemplate = this.templates.find(
        (template) => template.name === this.selectedTemplate
      );
      this.selectedTemplateMessage = selectedTemplate
        ? selectedTemplate.message
        : "";
      this.customMessage = "";
    },
    selectedGroups() {
      this.groupIdsArray = this.selectedGroups.map((selectedName) => {
        const group = this.groups.find((group) => group.name === selectedName);
        return group ? group._id : null;
      });
    },
  },
  mounted() {
    this.createGroupOptions();
  },
  computed: {
    selectedAllGroups() {
      return this.selectedGroups.length === this.groupOptions.length;
    },
    selectedSomeGroups() {
      return this.selectedGroups.length > 0 && !this.selectedAllGroups;
    },
    icon() {
      if (this.selectedAllGroups) return "mdi-close-box";
      if (this.selectedSomeGroups) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    templateOptions() {
      return this.templates.map((template) => template.name);
    },

    senderIdOptions() {
      return this.senderIds.map((sender) => sender.senderId);
    },
  },
  methods: {
    async sendSMS() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("send/sendGroupSMS", {
          groupIds: this.groupIdsArray,
          senderId: this.selectedSenderId,
          message: this.selectedTemplateMessage,
        });
        this.selectedTemplateMessage = null;
      }
    },
    createGroupOptions() {
      this.groupOptions = this.groups.map((group) => group.name);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAllGroups) {
          this.selectedGroups = [];
        } else {
          this.selectedGroups = this.groupOptions.slice();
        }
      });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
